import { render, staticRenderFns } from "./UserCompetencyAssignmentModal.vue?vue&type=template&id=73db4aa4&scoped=true"
import script from "./UserCompetencyAssignmentModal.vue?vue&type=script&lang=js"
export * from "./UserCompetencyAssignmentModal.vue?vue&type=script&lang=js"
import style0 from "./UserCompetencyAssignmentModal.vue?vue&type=style&index=0&id=73db4aa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73db4aa4",
  null
  
)

export default component.exports